import '@babel/polyfill'
import 'amfe-flexible'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import './styles/reset.less';
import 'vant/lib/index.css';
import './styles/index.less'
import { Toast } from 'vant';
import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.use(Toast);
Toast.setDefaultOptions({ duration: 1000 });

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
});
Vue.use(Vant);
new Vue({
  store,
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
